import { Flex, Spin } from 'antd';

export function FetchingDataLoading() {
  return (
    <Flex align="center" justify="center" className="fetching-data-loading">
      <Spin />
    </Flex>
  );
}
